import React from 'react';
import {AppRoutes} from './Routes/routes';
import 'bootstrap/dist/css/bootstrap.min.css';
function App() {
  return (
    <AppRoutes />
);
}

export default App;
